import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export enum DialogType {
    None = 0,
    Warning = 1,
    Error = 2,
    Question = 3,
    Info = 4
}

export interface DialogData {
    title: string;
    content: string;
    yes: string;
    no: string;
    type: DialogType;
  }

@Component({
    selector: 'app-medi-dialog',
    templateUrl: './medi-dialog.component.html',
    styleUrls: ['./medi-dialog.component.scss'],
    standalone: false
})

export class MediDialogComponent implements OnInit {
    @Input() title: string;

  constructor(public dialogRef: MatDialogRef<MediDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {
  }

}
